import { getAddressDetails, getAddressesLookup } from './addressService';
import { default as permitService } from './permitService';

const addressService = {
  getAddressDetails,
  getAddressesLookup
};

export { addressService, permitService };
